import React from "react";

export const SideNav = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g id="menu-right-alt" transform="translate(0)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M4,6.522A1.511,1.511,0,0,1,5.5,5h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,6.522Z"
          transform="translate(-4 -5)"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M4,18.522A1.511,1.511,0,0,1,5.5,17h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,18.522Z"
          transform="translate(-4 -4.045)"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M11.523,11a1.522,1.522,0,0,0,0,3.045H23.7A1.522,1.522,0,0,0,23.7,11Z"
          transform="translate(-1.225 -4.523)"
        />
      </g>
    </svg>
  );
};

export const AddImageIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z"
        fill="#0658C2"
      ></path>
      <path d="M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z" fill="#0658C2"></path>
      <path
        d="M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z"
        fill="#0658C2"
      ></path>
    </svg>
  );
};

export const BackButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-left-fill"
      viewBox="0 0 16 16"
    >
      <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"></path>
    </svg>
  );
};

export const BreadcrumsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
      ></path>
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-copy"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-check-lg"
      viewBox="0 0 16 16"
    >
      <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
    </svg>
  );
};

export const ChannelIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"></path>
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi-plus-lg"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
      ></path>
    </svg>
  );
};

export const MyDashBoardIcon = () => {
  return (
<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg"><path d="M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"></path></svg>
  );
};

export const GroupTypesIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="89.3" height="61" viewBox="0 0 89.3 61">
      <g id="Group_27" data-name="Group 27" transform="translate(-5.4 -19.5)">
        <g id="Group_19" data-name="Group 19">
          <path
            id="Path_71"
            data-name="Path 71"
            d="M50,47.7A14.1,14.1,0,1,1,64.1,33.6,14.084,14.084,0,0,1,50,47.7Zm0-25.2A11.1,11.1,0,1,0,61.1,33.6,11.139,11.139,0,0,0,50,22.5Z"
          />
        </g>
        <g id="Group_25" data-name="Group 25">
          <g id="Group_20" data-name="Group 20">
            <path
              id="Path_72"
              data-name="Path 72"
              d="M79.1,48.9A9.9,9.9,0,1,1,89,39,9.859,9.859,0,0,1,79.1,48.9Zm0-16.8A6.9,6.9,0,1,0,86,39,6.914,6.914,0,0,0,79.1,32.1Z"
            />
          </g>
          <g id="Group_21" data-name="Group 21">
            <path
              id="Path_73"
              data-name="Path 73"
              d="M20.9,48.9A9.9,9.9,0,1,1,30.8,39,9.859,9.859,0,0,1,20.9,48.9Zm0-16.8A6.9,6.9,0,1,0,27.8,39,6.914,6.914,0,0,0,20.9,32.1Z"
            />
          </g>
          <g id="Group_24" data-name="Group 24">
            <g id="Group_22" data-name="Group 22">
              <path
                id="Path_74"
                data-name="Path 74"
                d="M79.2,71a58.831,58.831,0,0,1-8.6-.5l-1.2-.2V68.6a22.18,22.18,0,0,0-3.8-12.2l-.5-.7.4-.8c2.7-5.4,8.1-8.9,13.6-8.9,8.3,0,15.5,7.5,15.6,16.5C94.7,71,86.8,71,79.2,71Zm-6.8-3.3a58.9,58.9,0,0,0,6.8.3c9.5,0,12.5-.8,12.5-5.5C91.6,55.2,85.8,49,79.1,49a12.522,12.522,0,0,0-10.6,6.5A25.071,25.071,0,0,1,72.4,67.7Z"
              />
            </g>
            <g id="Group_23" data-name="Group 23">
              <path
                id="Path_75"
                data-name="Path 75"
                d="M20.9,71c-7.6,0-15.5,0-15.5-8.5C5.4,53.6,12.5,46,20.9,46a15.558,15.558,0,0,1,13.6,8.9l.4.8-.5.7a20.978,20.978,0,0,0-3.7,12.1v1.7l-1.2.2A45.5,45.5,0,0,1,20.9,71Zm0-22C14.2,49,8.4,55.3,8.4,62.5c0,4.7,3,5.5,12.5,5.5a58.9,58.9,0,0,0,6.8-.3,23.938,23.938,0,0,1,3.8-12.2A12.522,12.522,0,0,0,20.9,49Z"
              />
            </g>
          </g>
        </g>
        <g id="Group_26" data-name="Group 26">
          <path
            id="Path_76"
            data-name="Path 76"
            d="M50,80.5c-11.5,0-22.4,0-22.4-11.9,0-12.7,10.5-23.9,22.4-23.9S72.4,55.9,72.4,68.6C72.4,80.5,61.5,80.5,50,80.5Zm0-32.8c-10.3,0-19.4,9.8-19.4,20.9,0,8.1,5.9,8.9,19.4,8.9s19.4-.8,19.4-8.9C69.4,57.5,60.3,47.7,50,47.7Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const RolesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-people"
      viewBox="0 0 16 16"
    >
      <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
    </svg>
  );
};

export const FileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-file-earmark"
      viewBox="0 0 16 16"
    >
      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
    </svg>
  );
};

export const PermissionsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-database-lock"
      viewBox="0 0 16 16"
    >
      <path d="M13 5.698a5 5 0 0 1-.904.525C11.022 6.711 9.573 7 8 7s-3.022-.289-4.096-.777A5 5 0 0 1 3 5.698V7c0 .374.356.875 1.318 1.313C5.234 8.729 6.536 9 8 9c.666 0 1.298-.056 1.876-.156-.43.31-.804.693-1.102 1.132A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777A5 5 0 0 1 3 8.698V10c0 .374.356.875 1.318 1.313C5.234 11.729 6.536 12 8 12h.027a4.6 4.6 0 0 0-.017.8A2 2 0 0 0 8 13c-1.573 0-3.022-.289-4.096-.777A5 5 0 0 1 3 11.698V13c0 .374.356.875 1.318 1.313C5.234 14.729 6.536 15 8 15c0 .363.097.704.266.997Q8.134 16.001 8 16c-1.573 0-3.022-.289-4.096-.777C2.875 14.755 2 14.007 2 13V4c0-1.007.875-1.755 1.904-2.223C4.978 1.289 6.427 1 8 1s3.022.289 4.096.777C13.125 2.245 14 2.993 14 4v4.256a4.5 4.5 0 0 0-1.753-.249C12.787 7.654 13 7.289 13 7zm-8.682-3.01C3.356 3.124 3 3.625 3 4c0 .374.356.875 1.318 1.313C5.234 5.729 6.536 6 8 6s2.766-.27 3.682-.687C12.644 4.875 13 4.373 13 4c0-.374-.356-.875-1.318-1.313C10.766 2.271 9.464 2 8 2s-2.766.27-3.682.687Z" />
      <path d="M9 13a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1" />
    </svg>
  );
};

export const MyDirectoryIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 24 24"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM5.5 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM6.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 12.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Zm.75-4.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM9 5.75A.75.75 0 0 1 9.75 5h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 9 5.75ZM13.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm-.75-2.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75ZM13.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"></path>
      <path d="M2 20V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v17c0 .173-.022.34-.063.5H20a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.2-.4l-.5-.375a.75.75 0 0 1 .9-1.2l.5.375c.504.378.8.97.8 1.6v8a2 2 0 0 1-2 2h-3.562a.767.767 0 0 1-.166-.018c-.089.012-.18.018-.272.018h-3.75a.75.75 0 0 1-.75-.75V19h-3v2.25a.75.75 0 0 1-.75.75H4a2 2 0 0 1-2-2Zm2 .5h3v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5Z"></path>
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-arrows-fullscreen"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.015" height="15.336" viewBox="0 0 24.015 15.336">
      <g id="Group_5530" data-name="Group 5530" transform="translate(-6.075 -22)">
        <path
          id="Path_16648"
          data-name="Path 16648"
          d="M25.791,25.007A12.757,12.757,0,0,0,18.082,22a12.757,12.757,0,0,0-7.709,3.007A24.009,24.009,0,0,0,6.3,29.025a1.028,1.028,0,0,0,0,1.285,25.145,25.145,0,0,0,4.073,4.018,12.881,12.881,0,0,0,7.709,3.007,12.819,12.819,0,0,0,7.709-3.007,24.009,24.009,0,0,0,4.073-4.018,1.028,1.028,0,0,0,0-1.285A22.056,22.056,0,0,0,25.791,25.007ZM18.082,35.215c-5.358,0-9.561-4.385-10.491-5.561.957-1.175,5.133-5.561,10.491-5.561s9.51,4.385,10.439,5.561C27.592,30.83,23.44,35.215,18.082,35.215Z"
          fill="#fff"
        ></path>
        <path
          id="Path_16649"
          data-name="Path 16649"
          d="M36.921,32a4.921,4.921,0,1,0,4.921,4.921A4.935,4.935,0,0,0,36.921,32Zm0,8.748a3.827,3.827,0,1,1,3.827-3.827A3.838,3.838,0,0,1,36.921,40.748Z"
          transform="translate(-18.838 -7.266)"
          fill="#fff"
        ></path>
        <path
          id="Path_16650"
          data-name="Path 16650"
          d="M40.9,43.388h1.093a1.4,1.4,0,0,1,1.394-1.394V40.9A2.5,2.5,0,0,0,40.9,43.388Z"
          transform="translate(-25.305 -13.733)"
          fill="#fff"
        ></path>
      </g>
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-download"
      viewBox="0 0 16 16"
    >
      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_3141" data-name="Group 3141" transform="translate(-24.2 -24.2)">
        <path
          id="Path_14272"
          data-name="Path 14272"
          d="M29.781,48.2H42.619A5.6,5.6,0,0,0,48.2,42.619h0V38.991a.93.93,0,0,0-1.86,0v3.628a3.732,3.732,0,0,1-3.721,3.721H29.781a3.732,3.732,0,0,1-3.721-3.721V29.781a3.732,3.732,0,0,1,3.721-3.721h3.628a.93.93,0,0,0,0-1.86H29.781A5.6,5.6,0,0,0,24.2,29.781V42.619A5.6,5.6,0,0,0,29.781,48.2Z"
          fill="#333"
        ></path>
        <path
          id="Path_14273"
          data-name="Path 14273"
          d="M50.482,25.677l-9.488,9.488a.9.9,0,0,0-.233.419l-1.3,4.651A.93.93,0,0,0,40.11,41.4a.951.951,0,0,0,.512,0l4.651-1.3a1.886,1.886,0,0,0,.419-.233l9.535-9.488a3.313,3.313,0,0,0,0-4.7,3.369,3.369,0,0,0-4.744,0ZM41.645,39.165l.465-1.581,1.163,1.163Zm12.186-10.14L45.04,37.816,42.994,35.77l8.791-8.791a1.462,1.462,0,0,1,2.047.14A1.478,1.478,0,0,1,53.831,29.026Z"
          transform="translate(-8.142 -0.267)"
          fill="#333"
        ></path>
      </g>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#ca353b"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const VideoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31.095" height="22.366" viewBox="0 0 31.095 22.366">
      <g id="Group_6125" data-name="Group 6125" transform="translate(-477.453 -257.817)">
        <path
          id="Path_17557"
          data-name="Path 17557"
          d="M22.822,13.991a2.925,2.925,0,0,0,1.037,2.138l1.455,1.222a2.909,2.909,0,0,0,4.78-2.226V7.241a2.909,2.909,0,0,0-4.78-2.226L23.86,6.237a2.89,2.89,0,0,0-1.037,2.124m0,5.63v1.556A5.819,5.819,0,0,1,17,21.366H6.819A5.819,5.819,0,0,1,1,15.547V6.819A5.819,5.819,0,0,1,6.819,1H17a5.819,5.819,0,0,1,5.819,5.819V8.361m0,5.63V8.361"
          transform="translate(477.453 257.817)"
          fill="none"
          stroke="#333"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        ></path>
      </g>
    </svg>
  );
};

export const SimApps = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
      <g id="Group_2822" data-name="Group 2822" transform="translate(-1848 -23)">
        <g id="Group_2823" data-name="Group 2823" transform="translate(-2144 -1086)">
          <g id="Group_2826" data-name="Group 2826" transform="translate(-4)">
            <g id="Path_14087" data-name="Path 14087" transform="translate(4016 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14088" data-name="Path 14088" transform="translate(4016 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14093" data-name="Path 14093" transform="translate(4016 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2825" data-name="Group 2825" transform="translate(-2)">
            <g id="Path_14086" data-name="Path 14086" transform="translate(4004 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14089" data-name="Path 14089" transform="translate(4004 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14092" data-name="Path 14092" transform="translate(4004 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2824" data-name="Group 2824">
            <g id="Path_14085" data-name="Path 14085" transform="translate(3992 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14090" data-name="Path 14090" transform="translate(3992 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14091" data-name="Path 14091" transform="translate(3992 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.297" height="19.35" viewBox="0 0 21.297 19.35">
      <g id="Group_4203" data-name="Group 4203" transform="translate(0 -1)">
        <path
          id="Path_15265"
          data-name="Path 15265"
          d="M17.51,12.814a3.768,3.768,0,1,1-3.79,3.768A3.782,3.782,0,0,1,17.51,12.814Zm0,1.825a1.942,1.942,0,1,0,1.962,1.942A1.956,1.956,0,0,0,17.51,14.64ZM8.616,15.717a.913.913,0,1,1,0,1.825H.948a.913.913,0,1,1,0-1.825ZM3.788,1A3.768,3.768,0,1,1,0,4.769,3.783,3.783,0,0,1,3.788,1Zm0,1.825A1.942,1.942,0,1,0,5.751,4.769,1.956,1.956,0,0,0,3.788,2.825ZM19.7,3.921a.913.913,0,0,1,0,1.825H12.037a.913.913,0,0,1,0-1.825Z"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export const PDFIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29.384" height="30.912" viewBox="0 0 29.384 30.912">
      <path
        id="pdf"
        d="M17.735,1.091V2.826c0,2.556,0,3.833.5,4.807a4.466,4.466,0,0,0,1.994,1.993c.977.5,2.255.5,4.811.5h1.737m-9.04-9.037A18.079,18.079,0,0,0,15.223,1H12.258C8.85,1,7.146,1,5.844,1.669A6.046,6.046,0,0,0,3.185,4.317c-.663,1.308-.663,3.012-.663,6.42v3.956m15.213-13.6a3.687,3.687,0,0,1,.421.076,6.149,6.149,0,0,1,1.759.73,13.192,13.192,0,0,1,2.194,1.948l1.9,1.917a12.61,12.61,0,0,1,1.956,2.191,5.878,5.878,0,0,1,.808,2.176m0,0a18.587,18.587,0,0,1,.088,2.51v2.054M1,29.906V19.256H3.282a3.8,3.8,0,0,1,0,7.607H1m21.3,3.043V19.256h6.085m0,6.085H22.3M11.649,19.256V29.906h.761a5.325,5.325,0,0,0,0-10.649Z"
        transform="translate(0 0.007)"
        fill="none"
        stroke="#333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      ></path>
    </svg>
  );
};

export const SearchesCIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)" opacity="0.5">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x-lg"
      viewBox="0 0 16 16"
    >
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-left-fill"
      viewBox="0 0 16 16"
    >
      <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"></path>
    </svg>
  );
};
export const FillUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-up-fill"
      viewBox="0 0 16 16"
    >
      <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
    </svg>
  );
};

export const FillDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  );
};

export const DisableDeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#9aa9a3"
          />
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#9aa9a3"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#9aa9a3"
          />
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#9aa9a3"
          />
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#9aa9a3"
          />
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#9aa9a3"
          />
        </g>
      </g>
    </svg>
  );
};

export const EnableDeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#ca353b"
          />
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#ca353b"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#ca353b"
          />
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#ca353b"
          />
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#ca353b"
          />
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#ca353b"
          />
        </g>
      </g>
    </svg>
  );
};



export const NoDataImage = () => {
  return (
    <svg width="345" height="287" viewBox="0 0 345 287" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3694_8732)">
        <g filter="url(#filter0_d_3694_8732)">
          <path
            d="M153.54 54.5382C153.473 54.5382 153.406 54.5358 153.339 54.5316C148.913 54.2473 133.77 52.1057 124.726 36.4726C124.058 35.3187 124.19 33.8504 125.055 32.8199C132.607 26.6791 138.507 20.033 141.989 12.6482C142.618 11.899 143.562 11.4895 144.517 11.5064C145.498 11.5295 146.401 11.9912 146.997 12.7729C151.29 18.4135 159.767 28.3988 168.297 31.8997C169.255 32.2936 169.949 33.0927 170.201 34.0937C170.45 35.0862 170.219 36.1094 169.567 36.9008L156.001 53.3699C155.391 54.1106 154.483 54.5382 153.54 54.5382Z"
            fill="#E6E6E6"
          />
          <path
            d="M127.854 33.8121C127.623 34.0879 127.581 34.4812 127.749 34.792C135.931 49.8536 150.558 51.0352 153.407 51.1189C153.682 51.1346 153.939 51.0111 154.113 50.7997L167.582 34.4493C167.773 34.2174 167.831 33.9217 167.744 33.6362C167.655 33.3496 167.438 33.1358 167.147 33.0515C157.999 30.3787 148.401 17.9989 145.677 14.2679C145.518 14.0499 145.272 13.9192 145.003 13.9102C144.726 13.9075 144.474 14.0162 144.297 14.2258C140.4 21.8228 134.943 28.3679 127.854 33.8121Z"
            fill="white"
          />
          <path
            d="M134.637 37.3389L146.846 24.8935C147.681 24.0427 146.373 22.7334 145.537 23.5853L133.328 36.0307C132.494 36.8814 133.801 38.1907 134.637 37.3389Z"
            fill="#E6E6E6"
          />
          <path
            d="M142.006 40.8469C145.375 37.8275 148.304 34.3315 150.701 30.4953C151.334 29.4827 149.734 28.5529 149.103 29.5615C146.785 33.2703 143.955 36.6199 140.697 39.5387C139.809 40.335 141.121 41.6399 142.006 40.8469Z"
            fill="#E6E6E6"
          />
          <path
            d="M148.648 45.0439C151.715 41.6463 154.327 37.8545 156.383 33.7643C156.916 32.7032 155.32 31.7653 154.785 32.8305C152.799 36.7824 150.304 40.4523 147.339 43.7356C146.543 44.6175 147.847 45.9299 148.648 45.0439Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter1_d_3694_8732)">
          <path
            d="M164.643 59.4718C164.576 59.4718 164.509 59.4694 164.442 59.4652C160.017 59.1809 144.874 57.0393 135.83 41.4062C135.162 40.2522 135.294 38.784 136.158 37.7535C143.334 31.5317 148.736 24.7282 153.093 17.5818C153.722 16.8326 154.666 16.4231 155.621 16.44C156.601 16.4631 157.505 16.9248 158.1 17.7065C162.394 23.3471 170.871 33.3324 179.4 36.8333C180.359 37.2272 181.053 38.0263 181.304 39.0273C181.554 40.0198 181.323 41.043 180.671 41.8344L167.105 58.3034C166.495 59.0442 165.586 59.4718 164.643 59.4718Z"
            fill="#E6E6E6"
          />
          <path
            d="M138.958 38.7457C138.727 39.0215 138.685 39.4148 138.853 39.7256C147.035 54.7872 161.662 55.9688 164.511 56.0525C164.785 56.0682 165.042 55.9447 165.216 55.7333L178.686 39.3829C178.876 39.151 178.935 38.8553 178.847 38.5698C178.759 38.2832 178.541 38.0694 178.25 37.9851C169.103 35.3123 159.505 22.9325 156.781 19.2015C156.621 18.9835 156.375 18.8528 156.106 18.8438C155.829 18.8411 155.577 18.9498 155.401 19.1594C150.732 26.9152 145.48 33.7903 138.958 38.7457Z"
            fill="white"
          />
          <path
            d="M145.74 42.2725L157.95 29.8271C158.784 28.9763 157.477 27.667 156.641 28.5188L144.432 40.9643C143.597 41.815 144.905 43.1243 145.74 42.2725Z"
            fill="#E6E6E6"
          />
          <path
            d="M153.109 45.7805C156.479 42.7611 159.407 39.265 161.805 35.4289C162.438 34.4163 160.837 33.4865 160.207 34.4951C157.889 38.2039 155.058 41.5535 151.801 44.4722C150.912 45.2686 152.224 46.5735 153.109 45.7805Z"
            fill="#E6E6E6"
          />
          <path
            d="M159.751 49.9775C162.819 46.5799 165.43 42.7881 167.486 38.6979C168.02 37.6368 166.424 36.6989 165.888 37.7641C163.902 41.716 161.407 45.3859 158.443 48.6692C157.646 49.5511 158.951 50.8635 159.751 49.9775Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter2_d_3694_8732)">
          <path
            d="M286.164 174.179C286.097 174.179 286.03 174.176 285.963 174.172C281.538 173.888 266.395 171.746 257.351 156.113C256.683 154.959 256.815 153.491 257.679 152.461L274.614 132.289C275.243 131.54 276.187 131.13 277.142 131.147C278.122 131.17 279.381 131.461 279.621 132.414C281.572 140.155 289.974 150.207 300.921 151.54C301.95 151.666 302.574 152.733 302.825 153.734C303.075 154.727 302.844 155.75 302.192 156.541L288.626 173.01C288.016 173.751 287.107 174.179 286.164 174.179Z"
            fill="#E6E6E6"
          />
          <path
            d="M260.479 153.453C260.248 153.729 260.206 154.122 260.374 154.433C268.556 169.494 283.183 170.676 286.032 170.76C286.306 170.775 286.563 170.652 286.737 170.44L300.207 154.09C300.397 153.858 300.456 153.562 300.368 153.277C300.28 152.99 300.074 152.706 299.771 152.692C288.127 152.146 278.775 139.557 278.302 133.909C278.279 133.64 277.896 133.56 277.627 133.551C277.35 133.548 277.098 133.657 276.922 133.866L260.479 153.453Z"
            fill="white"
          />
          <path
            d="M267.261 156.98L279.47 144.534C280.305 143.683 278.998 142.374 278.162 143.226L265.953 155.671C265.118 156.522 266.426 157.831 267.261 156.98Z"
            fill="#E6E6E6"
          />
          <path
            d="M274.63 160.487C278 157.468 280.928 153.972 283.326 150.136C283.959 149.123 282.358 148.194 281.728 149.202C279.41 152.911 276.579 156.261 273.322 159.179C272.433 159.976 273.745 161.28 274.63 160.487Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.272 164.684C284.34 161.287 286.951 157.495 289.007 153.405C289.541 152.344 287.945 151.406 287.409 152.471C285.423 156.423 282.928 160.093 279.964 163.376C279.167 164.258 280.472 165.571 281.272 164.684Z"
            fill="#E6E6E6"
          />
        </g>
        <path
          d="M311.53 276.311C312.804 276.391 313.509 274.808 312.544 273.885L312.449 273.504C312.461 273.474 312.474 273.443 312.487 273.413C313.775 270.34 318.143 270.362 319.421 273.438C320.555 276.169 321.999 278.905 322.355 281.792C322.514 283.067 322.442 284.365 322.159 285.616C324.817 279.812 326.215 273.475 326.215 267.102C326.215 265.501 326.128 263.9 325.948 262.302C325.801 260.996 325.598 259.697 325.335 258.411C323.913 251.456 320.833 244.832 316.39 239.299C314.255 238.132 312.474 236.308 311.398 234.121C311.012 233.333 310.709 232.484 310.565 231.62C310.808 231.652 311.482 227.951 311.299 227.724C311.637 227.21 312.243 226.955 312.613 226.454C314.453 223.96 316.988 224.395 318.311 227.784C321.137 229.21 321.165 231.576 319.43 233.85C318.327 235.298 318.175 237.256 317.207 238.805C317.307 238.933 317.41 239.056 317.51 239.184C319.336 241.526 320.916 244.043 322.248 246.688C321.872 243.749 322.427 240.208 323.375 237.925C324.453 235.324 326.474 233.134 328.254 230.886C330.392 228.185 334.777 229.363 335.153 232.787C335.157 232.82 335.16 232.853 335.164 232.886C334.9 233.036 334.641 233.194 334.388 233.361C332.944 234.315 333.443 236.552 335.153 236.816L335.192 236.822C335.096 237.774 334.933 238.718 334.694 239.646C336.977 248.475 332.047 251.69 325.008 251.835C324.853 251.914 324.701 251.994 324.546 252.07C325.259 254.077 325.829 256.136 326.251 258.224C326.63 260.068 326.893 261.932 327.04 263.804C327.223 266.166 327.207 268.54 327.008 270.898L327.02 270.814C327.526 268.217 328.937 265.792 330.985 264.111C334.035 261.605 338.345 260.683 341.637 258.669C343.221 257.699 345.251 258.952 344.975 260.788L344.961 260.876C344.471 261.076 343.993 261.307 343.531 261.565C343.266 261.715 343.007 261.873 342.754 262.04C341.311 262.995 341.81 265.231 343.52 265.495L343.559 265.501C343.587 265.505 343.61 265.509 343.638 265.513C342.798 267.508 341.626 269.361 340.16 270.958C338.732 278.665 332.6 279.396 326.04 277.152H326.036C325.319 280.275 324.271 283.326 322.924 286.233H311.809C311.769 286.11 311.733 285.982 311.697 285.859C312.725 285.923 313.761 285.863 314.773 285.676C313.948 284.664 313.123 283.644 312.299 282.633C312.279 282.613 312.263 282.593 312.247 282.573C311.828 282.055 311.406 281.541 310.988 281.023L310.988 281.023C310.961 279.433 311.152 277.849 311.53 276.311Z"
          fill="#F2F2F2"
        />
        <path
          d="M-19 286.5C-19 286.777 -18.4724 287 -17.8154 287H343.815C344.472 287 345 286.777 345 286.5C345 286.223 344.472 286 343.815 286H-17.8154C-18.4724 286 -19 286.223 -19 286.5Z"
          fill="#CCCCCC"
        />
        <g filter="url(#filter3_d_3694_8732)">
          <path d="M235.432 281.703L228.116 281.702L224.636 253.492L235.433 253.493L235.432 281.703Z" fill="#FFB6B6" />
          <path
            d="M210.368 281.537C210.14 281.92 210.02 283.158 210.02 283.604C210.02 284.975 211.132 286.086 212.503 286.086H235.158C236.093 286.086 236.852 285.328 236.852 284.393V283.45C236.852 283.45 237.972 280.616 235.665 277.123C235.665 277.123 232.797 279.858 228.512 275.574L227.248 273.285L218.101 279.973L213.031 280.597C211.922 280.734 210.939 280.576 210.368 281.537Z"
            fill="black"
          />
          <path d="M302.983 267.27L296.752 271.102L279.003 248.897L288.199 243.242L302.983 267.27Z" fill="#FFB6B6" />
          <path
            d="M281.549 280.257C281.556 280.703 282.102 281.821 282.336 282.2C283.055 283.368 284.584 283.732 285.752 283.014L305.048 271.146C305.845 270.656 306.093 269.613 305.603 268.817L305.109 268.014C305.109 268.014 304.578 265.013 300.782 263.246C300.782 263.246 299.773 267.078 293.878 265.674L291.602 264.387L287.316 274.875L283.325 278.062C282.452 278.759 281.531 279.14 281.549 280.257Z"
            fill="black"
          />
          <path
            d="M257.004 149.761C256.642 148.182 256.669 146.649 257.009 145.378L252.601 130.561L259.778 128.615L263.476 143.856C264.334 144.844 265.026 146.208 265.388 147.787C266.215 151.395 265.009 154.761 262.694 155.306C260.378 155.851 257.831 153.368 257.004 149.761Z"
            fill="#FFB6B6"
          />
          <path
            d="M216.17 50.9892C216.17 50.9892 227.736 45.9563 234.194 53.2292C240.072 59.8489 252.005 79.7687 250.779 81.7068L262.526 137.2L253.819 139.882L230.721 76.0517L216.17 50.9892Z"
            fill="#2F3A79"
          />
          <path
            d="M203.433 133.228L209.392 202.733L223.793 267.272L239.187 265.783L231.738 195.286L236.298 132.635L203.433 133.228Z"
            fill="black"
          />
          <path
            d="M204.665 148.309L241.781 207.381L284.13 258.176L297.135 249.808L258.241 190.535C252.288 164.426 245.695 140.257 233.614 132.744L204.665 148.309Z"
            fill="black"
          />
          <path
            d="M206.831 148.598C205.09 148.598 203.404 147.984 202.03 146.82C200.185 145.256 199.224 142.976 199.393 140.564L202.631 109.508L201.394 75.5954L201.402 75.5587L205.246 57.1299C205.284 56.5442 205.407 55.9242 205.605 55.3288L211.283 38.2629C212.304 35.1933 215.163 33.1309 218.399 33.1309H223.42C225.934 33.1309 228.267 34.379 229.661 36.47L234.056 43.061C234.348 43.4989 234.594 43.9689 234.788 44.4582L244.491 68.9405C244.799 69.7177 244.974 70.5353 245.012 71.3703L248.022 139.316C248.122 141.571 247.215 143.73 245.532 145.238C243.86 146.738 241.629 147.401 239.416 147.059C226.746 145.103 215.657 146.703 208.584 148.39C208 148.529 207.412 148.598 206.831 148.598Z"
            fill="#2F3A79"
          />
          <path
            d="M205.419 81.0995L196.978 74.6456C196.978 74.6456 200.95 39.397 211.379 39.397C221.807 39.397 227.269 33.4395 227.269 33.4395C227.269 33.4395 264.513 85.5677 254.085 91.5252C243.657 97.4827 229.256 94.504 229.256 94.504L224.183 49.9726C223.56 47.6186 220.32 47.3637 219.336 49.5913L205.419 81.0995Z"
            fill="#CA373C"
          />
          <path
            d="M219.307 31.6119C227.279 31.6119 233.742 25.1509 233.742 17.1809C233.742 9.21095 227.279 2.75 219.307 2.75C211.335 2.75 204.873 9.21095 204.873 17.1809C204.873 25.1509 211.335 31.6119 219.307 31.6119Z"
            fill="#FFB6B6"
          />
          <path
            d="M230.738 28.0909C229.436 28.5769 227.44 29.3326 226.138 29.8187C224.923 27.3985 226.411 26.1427 226.566 23.4395C226.617 22.5374 226.747 21.6343 226.672 20.7338C226.598 19.8334 226.288 18.909 225.609 18.3132C224.569 17.4017 222.838 17.55 221.832 18.4979C220.826 19.4458 220.539 21.0122 220.951 22.3319C216.993 20.6214 214.436 16.1341 214.982 11.8582C213.8 11.3949 212.589 10.9255 211.32 10.89C210.051 10.8546 208.691 11.3387 208.015 12.4129C207.541 13.1661 207.446 14.1223 206.914 14.8357C206.049 15.995 204.18 16.0848 203.032 15.2055C201.884 14.3261 201.444 12.728 201.689 11.3028C201.934 9.87757 200.152 6.96906 201.15 5.92183C201.83 5.20743 205.208 6.21968 205.967 5.58948C206.659 5.01453 207.355 4.43767 208.118 3.96069C209.087 3.35524 210.16 2.91678 211.276 2.67041C212.332 2.43736 213.416 2.37615 214.496 2.31568C215.591 2.25429 217.107 0.0731585 218.203 0.0117658C221.429 -0.168977 224.312 1.77848 227.407 2.70564C230.502 3.63281 232.449 6.29529 234.162 9.03402C236.602 12.9351 235.773 17.2095 234.092 20.9397C233.677 21.8618 235.071 22.8307 234.864 23.8206C234.673 24.7408 233.81 25.4073 233.609 26.3254C233.436 27.1105 232.417 26.2009 232.174 26.9671C231.964 27.6282 231.346 28.0949 230.685 28.3059C230.024 28.517 229.317 28.5127 228.623 28.5064"
            fill="black"
          />
          <path
            d="M227.64 33.0703L228.148 33.4406L229.431 34.3742C233.287 37.1809 232.929 43.0398 228.759 45.3557L223.545 37.0292"
            fill="#CA373C"
          />
          <path
            d="M154.843 50.2438C156.145 51.1026 157.145 52.1841 157.753 53.2875L170.67 60.6858L166.969 66.7279L154.264 58.5726C153.01 58.4476 151.622 57.9539 150.321 57.0951C147.347 55.1331 145.948 52.009 147.197 50.117C148.446 48.2251 151.869 48.2818 154.843 50.2438Z"
            fill="#FFB6B6"
          />
          <path
            d="M215.62 42.4458C223.857 37.3952 232.135 48.9615 224.811 55.2633L224.786 55.2847L195.521 82.8029L160.497 65.512L163.96 56.1762L191.095 66.9224L211.45 45.7967C212.867 44.3784 214.261 43.2792 215.62 42.4458Z"
            fill="#2F3A79"
          />
        </g>
        <path
          d="M42.1282 88.3926C41.4478 88.3926 40.8945 88.9457 40.8945 89.626V108.744C40.8945 109.424 41.4478 109.977 42.1282 109.977C42.8087 109.977 43.362 109.424 43.362 108.744V89.626C43.362 88.9457 42.8087 88.3926 42.1282 88.3926Z"
          fill="black"
        />
        <path
          d="M54.2193 106.814C58.4653 106.814 61.9074 103.445 61.9074 99.2898C61.9074 95.1343 58.4653 91.7656 54.2193 91.7656C49.9733 91.7656 46.5312 95.1343 46.5312 99.2898C46.5312 103.445 49.9733 106.814 54.2193 106.814Z"
          fill="url(#paint0_radial_3694_8732)"
        />
        <path
          d="M115.851 96.7165H74.4693C73.0496 96.7165 71.8945 95.5617 71.8945 94.1424C71.8945 92.7231 73.0496 91.5684 74.4693 91.5684H115.851C117.271 91.5684 118.426 92.7231 118.426 94.1424C118.426 95.5617 117.271 96.7165 115.851 96.7165Z"
          fill="white"
        />
        <path
          d="M148.146 105.429H74.4693C73.0496 105.429 71.8945 104.275 71.8945 102.855C71.8945 101.436 73.0496 100.281 74.4693 100.281H148.146C149.565 100.281 150.72 101.436 150.72 102.855C150.72 104.275 149.565 105.429 148.146 105.429Z"
          fill="white"
        />
        <path
          d="M7.68808 147.503C11.9341 147.503 15.3762 144.135 15.3762 139.979C15.3762 135.824 11.9341 132.455 7.68808 132.455C3.44207 132.455 0 135.824 0 139.979C0 144.135 3.44207 147.503 7.68808 147.503Z"
          fill="url(#paint1_radial_3694_8732)"
        />
        <path
          d="M69.3199 137.406H27.938C26.5183 137.406 25.3633 136.251 25.3633 134.832C25.3633 133.413 26.5183 132.258 27.938 132.258H69.3199C70.7396 132.258 71.8946 133.413 71.8946 134.832C71.8946 136.251 70.7396 137.406 69.3199 137.406Z"
          fill="white"
        />
        <path
          d="M79.8961 172.179C84.1421 172.179 87.5842 168.811 87.5842 164.655C87.5842 160.5 84.1421 157.131 79.8961 157.131C75.6501 157.131 72.208 160.5 72.208 164.655C72.208 168.811 75.6501 172.179 79.8961 172.179Z"
          fill="url(#paint2_radial_3694_8732)"
        />
        <path
          d="M173.823 170.793H100.146C98.7268 170.793 97.5718 169.638 97.5718 168.219C97.5718 166.799 98.7268 165.645 100.146 165.645H173.823C175.243 165.645 176.398 166.799 176.398 168.219C176.398 169.638 175.243 170.793 173.823 170.793Z"
          fill="white"
        />
        <path
          d="M155.621 31.4898C159.867 31.4898 163.309 28.1211 163.309 23.9656C163.309 19.8101 159.867 16.4414 155.621 16.4414C151.375 16.4414 147.933 19.8101 147.933 23.9656C147.933 28.1211 151.375 31.4898 155.621 31.4898Z"
          fill="url(#paint3_radial_3694_8732)"
        />
        <path
          d="M297.135 157.628C301.381 157.628 304.823 154.26 304.823 150.104C304.823 145.949 301.381 142.58 297.135 142.58C292.889 142.58 289.447 145.949 289.447 150.104C289.447 154.26 292.889 157.628 297.135 157.628Z"
          fill="url(#paint4_radial_3694_8732)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3694_8732"
          x="112.303"
          y="3.50586"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter1_d_3694_8732"
          x="123.406"
          y="8.43945"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter2_d_3694_8732"
          x="244.927"
          y="123.146"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter3_d_3694_8732"
          x="136.74"
          y="-6"
          width="179.114"
          height="306.086"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.2193 99.2898) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.68808 139.979) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.8961 164.655) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(155.621 23.9656) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(297.135 150.104) rotate(90) scale(7.52419 7.68807)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <clipPath id="clip0_3694_8732">
          <rect width="345" height="287" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};